import { render, staticRenderFns } from "./LandingItem.vue?vue&type=template&id=4808727e"
import script from "./LandingItem.vue?vue&type=script&lang=js"
export * from "./LandingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports